export interface UserDto {
  uniqueId: string;
  lastUpdated: string;
  firstName: string;
  lastName: string;
  email: string;
}

export enum KeyStatus {
  Inventory = 0,
  Active = 1,
  Blocked = 2,
  Deleted = 3
}

export interface KeyHistoryEntryDto {
  createdBy: string;
  created: string;
  updatedBy: string;
  lastUpdated: string;
  deletedBy: string | null;
  deleted: string | null;
  isDeleted: boolean;
  uniqueId: string;
  keyId: string;
  label: string;
  isActive: boolean;
  activationDate: string | null;
  activatedUser: UserDto | null;
  deactivationDate: string | null;
  deactivatedUser: UserDto | null;
  accountId: string;
  yearPrivateMileage: number;
  keyStatus: number;
  changedAt?: string;
  newLabel?: string;
  assignedToUser?: UserDto | null;
  newStatus?: number;
  changedByUser?: UserDto | null;
}

export type KeyHistoryResponseDto = KeyHistoryEntryDto[];
